import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { enumToMap } from 'helpers/commonHelpers';
import { SubIndustryOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const SubIndustrySelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Array.from(enumToMap(SubIndustryOptions)).map((e) => ({
        id: e[1],
        label: t(`intake_form.sub_industry_options.${e[0]}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default SubIndustrySelect;
